import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    paper: {
        width: '100%',
        height: '100%',
        borderRight: '1px solid #DDDDDD',
        borderRadius: 0,
        backgroundColor: '#FFFFFF',
        boxShadow: 'none',
    },
    title: {
        padding: '16px',
        fontFamily: 'Open Sans, sans-serif',
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '14px',
        color: '#676A6C',
        position: 'static',
    },
    tabButton: {
        padding: '8px 16px',
        height: 54,
        fontWeight: 400,
        '&.Mui-selected': {
            backgroundColor: '#F3F3F4',
            fontWeight: 600,
        },
    },
    tabText: {
        fontFamily: 'Open Sans, sans-serif',
        fontSize: '13px',
        lineHeight: '18px',
        color: '#676A6C',
    },
}));

export default useStyles;